<template>
  <div>
    <header id="header" class="page-section static-sticky dark">
      <div id="header-wrap">
        <div class="container clearfix">
          <div id="primary-menu-trigger">
            <i class="icon-reorder"></i>
          </div>
          <!-- Logo
          =============================================-->
          <div id="logo">
            <a
              href="#"
              class="standard-logo"
              :data-dark-logo="require('../assets/images/logo-dark.png')"
            >
              <img src="@/assets/images/logo.png" alt="forhair" />
            </a>
            <a
              href="#"
              class="retina-logo"
              :data-dark-logo="require('../assets/images/logo-dark@2x.png')"
            >
              <img src="@/assets/images/logo@2x.png" alt="forhair" />
            </a>
          </div>
          <!-- #logo end -->

          <!-- Primary Navigation
          =============================================-->
          <nav id="primary-menu">
            <ul class="one-page-menu">
              <li>
                <a href="#why" data-scrollto="#why">
                  <div>{{ $t('menuwhy') }}</div>
                </a>
              </li>
              <li>
                <a href="#surgery" data-scrollto="#surgery">
                  <div>{{ $t('menusurgery') }}</div>
                </a>
              </li>
              <li>
                <a href="#surgeryResult" data-scrollto="#surgeryResult">
                  <div>{{ $t('menusugeryresult') }}</div>
                </a>
              </li>
              <li>
                <a href="#star" data-scrollto="#star">
                  <div>{{ $t('menuforhairstar') }}</div>
                </a>
              </li>
              <!-- 
              <li>
                <a href="#review" data-href="#review">
                  <div>{{ $t('menureview') }}</div>
                </a>
              </li>
              <li>
                <a href="#counsel-form" data-href="#counsel-form">
                  <div>빠른상담</div>
                </a>
              </li> -->
            </ul>
            <div id="side-panel-trigger" class="side-panel-trigger">
              <a href="#"><i class="icon-building1"></i></a>
            </div>
          </nav>
          <!-- #primary-menu end -->
        </div>
      </div>
    </header>

    <section
      id="slider"
      class="slider-element slider-parallax full-screen dark"
      :style="getBackground"
    >
      <div class="slider-parallax-inner">
        <div class="container-fluid vertical-middle clearfix">
          <div class="heading-block title-center nobottomborder">
            <h2 class="display-3 t600 ls--2">
              <p style="font-size: 58px;">{{ $t('slogan') }}</p>
              FORHAIR
              <span
                class="text-rotater"
                data-separator="|"
                data-rotate="fadeIn"
                data-speed="2000"
              >
                <span class="t-rotate">{{ $t('seoul') }}|{{ $t('daego') }}|{{ $t('busan') }}</span>
              </span>
            </h2>
          </div>
          <div class="center bottommargin">
            <!-- <a
              href="//forhair.co.kr"
              class="button button-3d button-teal button-xlarge nobottommargin"
            >
              <i class="icon-search1"></i>자세히 알아보기
            </a> -->

            <a
              :href=getHome()
              class="button button-desc button-border button-rounded center"
              ><div>{{ $t('moredetail') }}</div>
              <span>FORHAIR</span></a
            >
            <!-- href="//www.forhair.co.kr/cs/cost_counseling.asp" -->
            <!-- <a
              hrea="#"
              data-scrollto="#counsel-form"
              class="button button-3d button-red button-xlarge nobottommargin"
            >
              <i class="icon-user2"></i>상담신청
            </a> -->
          </div>
        </div>
      </div>
    </section>
    <RealModelModal v-if="realmodelRecruitActivated" />
  </div>
</template>

<script>
// import PopupCounsel from "./popup/Counsel.vue";
import RealModelModal from "./popup/RealModelModal.vue";

export default {
  name: "LandinHeader",
  components: {
    RealModelModal
  },
  props: {
    msg: String
  },
  data() {
    return {
      bgImg: require("@/assets/images/landing/static.png"),
      realmodelRecruitActivated: false
    };
  },
  methods: {
    getHome(){
      return !this.$i18n.locale  || this.$i18n.locale == 'ko' ? 
                '//www.forhair.co.kr' : 
                '//www.forhair.co.kr/en';
    }
  },
  computed: {
    getBackground() {
      return {
        "background-Image": "url(" + this.bgImg + ")",
        "background-repeat": "no-repeat",
        "background-size": "cover"
      };
    }
  },
  mounted() {}
};
</script>

<style scoped></style>
